module.exports = __webpack_public_path__ + "img/list.db7c74c1.svg";